var $ = jQuery.noConflict();
let gutenbergScrollAnims = false,
    blockTriggerHeight = 300;
let windowSize = 0,
    windowHeight = 0;
let isMobile = false;

let childpostNavHeight = false;


$(document).ready(function(){
  updateWindowSizeMeta();
  console.log('ready? ok!');

  /*
   * Paragraph Drop Caps
   */
   if ( $('p.has-drop-cap').length > 0 ) {
     $('p.has-drop-cap').each(function(){
       dropCap($(this));
     });
   }

   $(".search-toggle").click(function(){
     $('.site-header').toggleClass('search-on');
   })

   if ( $('ol').length ) {
     $('ol').each(function(){
       if ( $(this)[0].hasAttribute('start') ) {
         $(this).css('counter-reset', 'orderedlist ' + ($(this).attr('start') - 1));
       }
     });
   }

   /*
    * Accordion Block
    */
    if( $('.block-accordion').length > 0 ){
      $('.block-accordion .accordion-row-title-cont').click(function(){
        console.log('open me!');
        $(this).parent().toggleClass('active');
        $(this).parent().find('.accordion-row-content').slideToggle();
      })
    }

    /*
     * Child menu
     */
    if($('#header-menu-valuing-respect .menu-item-with-children').length > 0){
      $('.menu-item-with-children').click(function(){
        console.log('toggle child menu');
        $(this).parent().toggleClass('sub-menu-open');
      });
    }


    /*
     * Gallery Block
     */
     if( $('.block-gallery-block').length > 0 ){
       $('.block-gallery-block').each(function(i, e){
         $(e).find('.block-gallery-inner').slick({
           slidesToShow:1,
           slidesToScroll: 1,
           adaptiveHeight: true,
           prevArrow: $(e).find('.nav-prev'),
           nextArrow: $(e).find('.nav-next'),
           fade: true
         });
         $(e).find('.block-gallery-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
           console.log(nextSlide);
           $(e).find('.block-gallery-nav .nav-count span').html(++nextSlide);
         });
       })
     }


    /*
     * footer slick
     */
     if($('.valuing-respect-related-slick').length > 0){
       $('.valuing-respect-related-slick-inner').slick({
         infinite: true,
         slidesToShow: 2.75,
         slidesToScroll: 1,
         prevArrow: $('.valuing-respect-related-arrow.arrow-prev'),
         nextArrow: $('.valuing-respect-related-arrow.arrow-next'),
         responsive: [
           {
             breakpoint: 800,
             settings:{
               slidesToShow: 1.5,
             }
           }
         ]
       });

       $('.valuing-respect-related-slick-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
         console.log(nextSlide);
         $('.valuing-respect-related-slick-dots button[key="' + nextSlide +'"]').click();
       });

       $('.valuing-respect-related-slick-dots button').click(function(){
         console.log('dott');
         $('.valuing-respect-related-slick-dots button').removeClass('active');
         $(this).addClass('active');
         $(this).parent().parent().parent().find('.valuing-respect-related-slick-inner').slick('slickGoTo', $(this).attr('key'));
       });
     }

     /*
      * Resources share
      */
      $('.sidebar-social-share-button').click(function(e){
        e.preventDefault();
        $(this).parent().find('.sidebar-social-share').slideToggle();
      });

      if($('.resource-share-cont').length > 0){
        $('.resource-share span, .resource-share svg').click(function(){
          $(this).parent().find('.desktop-share').toggle('slide');
          $(this).parent().find('.mobile-share').slideToggle();
        })


        var resourceArr = $('.single-resource .page-content .content-left p:first-child').html().split(' ');
        let newResourceArr = resourceArr;
        let resourceString = '<span class="dropcap">' + resourceArr[0].charAt(0) +'</span><span class="capitalize">' + resourceArr[0].substr(1) + ' ' + resourceArr[1] + ' ' + resourceArr[2] + '</span> ';
        $('.single-resource .page-content .content-left p:first-child').html(resourceString + newResourceArr.splice(3,newResourceArr.length).join(' '));
      }

      if ($('.resource-share-button').length > 0){
        $('.resource-share-button').click(function(){
          console.log($(this).next());
          $(this).next().toggleClass('active');
          // if ($(window).width() < 767) {
          //   $(this).next().slideToggle();
          // }
        });
      }


      /*
       * valuing respect resources landing
       */

      if($('.practical-resources-header').length > 0){
        if($('.practical-resources-resource').length > 1){
          $('.practical-resources-header').slick({
            dots: false,
            infinite: false,
            dots: true,
          })
        }
      }

      if( $('.featured-resources').length > 0 ) {
        $('.featured-resources').each(function(){
          const thisRef = $(this);
          const controlsContainer = $(this).next();

          $(thisRef).slick({
            centerMode: true,
            centerPadding: '60px',
            mobileFirst: true,
            dots: true,
            appendDots: controlsContainer,
            appendArrows: controlsContainer,
            prevArrow: '<div class="valuing-respect-related-arrow arrow-prev slick-arrow" style=""><svg viewBox="0 0 12 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Icon/Chevron" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M8.08066053,0.135353627 C7.91718006,-0.0451178755 7.64509368,-0.0451178755 7.47589711,0.135353627 C7.31241664,0.309728119 7.31241664,0.599945804 7.47589711,0.773913829 L10.5423944,4.04475657 L0.423372499,4.04475657 C0.187488091,4.04516304 0,4.24514497 0,4.49674826 C0,4.74835155 0.187488091,4.95483696 0.423372499,4.95483696 L10.5423944,4.95483696 L7.47589711,8.21958269 C7.31241664,8.4000542 7.31241664,8.69067835 7.47589711,8.86464637 C7.64509368,9.04511788 7.91756113,9.04511788 8.08066053,8.86464637 L11.8731026,4.81948333 C12.0422991,4.64510884 12.0422991,4.35489116 11.8731026,4.18092313 L8.08066053,0.135353627 Z" id="Path-Copy-6"></path></g></svg></div>',
            nextArrow: '<div class="valuing-respect-related-arrow arrow-next slick-arrow" style=""><svg viewBox="0 0 12 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Icon/Chevron" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M8.08066053,0.135353627 C7.91718006,-0.0451178755 7.64509368,-0.0451178755 7.47589711,0.135353627 C7.31241664,0.309728119 7.31241664,0.599945804 7.47589711,0.773913829 L10.5423944,4.04475657 L0.423372499,4.04475657 C0.187488091,4.04516304 0,4.24514497 0,4.49674826 C0,4.74835155 0.187488091,4.95483696 0.423372499,4.95483696 L10.5423944,4.95483696 L7.47589711,8.21958269 C7.31241664,8.4000542 7.31241664,8.69067835 7.47589711,8.86464637 C7.64509368,9.04511788 7.91756113,9.04511788 8.08066053,8.86464637 L11.8731026,4.81948333 C12.0422991,4.64510884 12.0422991,4.35489116 11.8731026,4.18092313 L8.08066053,0.135353627 Z" id="Path-Copy-6"></path></g></svg></div>',
            responsive: [
              {
                breakpoint: 768,
                settings: 'unslick'
              }
            ]
          });

          $(window).on('resize', function(){
            if ($(window).width() < 768 ) {
              $(thisRef).slick({
                centerMode: true,
                centerPadding: '60px',
                mobileFirst: true,
                dots: true,
                responsive: [
                  {
                    breakpoint: 768,
                    settings: 'unslick'
                  }
                ]
              });
            }
          });
        });
      }

      /*
       * valuing respect menu toggle
       */
       if($('.val-mobile-menu-toggle').length > 0 ){
         $('.val-mobile-menu-toggle').click(function(){
           $('.val-mobile-menu-pulldown').toggleClass('active');
           $('body').toggleClass('no-scroll');
         });
         $('#menu-valuing-respect .menu-item-has-children a').click(function(){
           $(this).parent().find('.sub-menu').slideToggle();
           $(this).parent().toggleClass('active');
         })
       }



       /*
        * email functions
        */
        $('.email-modal input[type="text"], .email-modal input[type="email"]').on('change', function(){
          if ( $(this).val() != '' ) {
            $(this).addClass('has-value');
          } else {
            $(this).removeClass('has-value');
          }
        });

        $('.email-modal__inner__close').on('click', function(){
          $(this).parent().parent().removeClass('open');
          $(this).parent().parent().find('.response').hide();
        }).on('keypress', function(){
          $(this).trigger('click');
        })

        $('#mce-responses .response').on('click', function(){
          $(this).fadeOut();
        });

        $('.subscribe-inputs input[type="email"], .resource-mobile-menu-newsletter input[type="email"]').keydown(function (e) {
            if (e.keyCode == 13) {
              e.preventDefault();
              $(this).parent().find('input[type="submit"]').click();
            }
        });

        $('.submit-container > input[type="submit"]').click(function(e){
          e.preventDefault();

          const email = $(this).parent().parent().find('input[type="email"]').val();

          $('.email-modal input.email').val( email );
          $('.email-modal input.email').trigger('change');
          $('.email-modal').addClass('open');

        }).on('keypress', function(){
          $(this).trigger('click');
        });


        $('.resource-show-more button').click(function(){
          $('.resources-block-resource').toggleClass('active');
          $(this).toggleClass('active');
        });


//Download Box Block:
if($(".fileDownload-fitlerInput").length >0){
 const dlDropdown = $('.fileDownload-fitlerInput').prettyDropdown();

$(".fileDownload-fitlerInput").on('change',function(){
  var classes="."+$(this).val();
  $(".fileColumn-file").css('opacity',.3);
  $(".fileColumn-file").each(function(){
    $(this).find('.download-checkboxes').prop('checked', false);
  });
  $(classes).css('opacity',1);
  $(classes).each(function(){
    $(this).find('.download-checkboxes').prop('checked', true);
  });

  $('.fileDownload-fitlerClear').prop('disabled', false);
});

$('.fileDownload-fitlerClear').on('click', function(){
  $('.fileDownload-fitlerInput').each(function() { this.selectedIndex = 0 });
  $('.filterList .selected').removeClass('selected').removeClass('hover');
  $('.filterList .disabled').prependTo('.filterList .prettydropdown ul').addClass('selected');
  $(".fileColumn-file").css('opacity',1);
  $(".fileColumn-file").each(function(){
    $(this).find('.download-checkboxes').prop('checked', false);
  });

  $(this).prop('disabled', true);
  dlDropdown.refresh();
}).on('keypress', function(e){
  e.preventDefault();
  $(this).trigger('click');
});


}


//IDTBLock

if($(".IDT_block").length > 0){
  $(".idt_column-step").on('click',function(){
    $(".step-active").removeClass("step-active");
    $(this).addClass("step-active");
  });



}


// var d = $(".shift-sidebar").offset().top - 120;

var fixed = false;
var unfixed = true;
//scrolling stuff
  $(window).scroll(function(){
    // console.log('what???');
    if($(this).scrollTop()>100){
      $(".site-header").addClass('scrolled');
    }else{
      $(".site-header").removeClass('scrolled');
    }

  });

  $('#site-navigation').scroll(function(){
    if($("#site-navigation").scrollTop() > 0){
      $('#masthead').addClass('menu-open-scroll');
    }else{
      $('#masthead').removeClass('menu-open-scroll');
    }

  });


  $('.menu-toggle').click(function(){
    $("#masthead").toggleClass('active');
    $("body").toggleClass('no-scroll');
  });


  $('.col-right-inner h6').click(function(){
    if($(window).width() < 767){
      $(this).parent().toggleClass('open');
      $(this).parent().find('.menu').slideToggle();
    }
  });

  if($(window).width() < 767){
    $('.menu-recent-work-feed').slick({
      infinite: false,
      slidesToShow: 1.75,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    })
  }


  $(window).resize(function(){
    if($('.menu-recent-work-feed').length){
      if($(window).width() < 767){
        $('.menu-recent-work-feed').slick({
          infinite: false,
          slidesToShow: 1.25,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        })
      }else{
        $('.menu-recent-work-feed').slick('unslick');
      }
    }

  })


  if($('span.anchors').length > 0){
    console.log('yes to anchors');
    $('.page-content .two-column-content .content-left h2').each(function(i, e){
      let newID = $(e).html().replace(/[^\w\s]/gi, '').replace(/ /g, "-");
      $(e).attr('id', newID);
      $('.content-right .shift-sidebar-box.anchor-list ul').append('<li><a class="arrow-link in-page" href="#' + newID +'">' + $(e).html() +'</a></li>');
    });


    $('.anchor-list ul li a.in-page').click(function(e){
      e.preventDefault();
      $('html,body').animate({
        scrollTop: ($($(this).attr('href')).offset().top - 100) + 'px'
      }, 500);

    });

  }


  // mobile page menus
  if ( $('.shift-sidebar-box').length ) {
    $('.shift-sidebar-box h6').click(function(){
      if ( $(window).width() < 767 ) {
        $(this).parent().toggleClass('expanded');
        $(this).next().slideToggle(500);
      }
    });
  }
var animated_highlighting = false;
if(jsdata.animated_highlighting){
  animated_highlighting = true;
}
console.log(animated_highlighting);

  if ( animated_highlighting && $('.content-left strong').length && (!( window.location.hash != "" && $(window.location.hash).length )) ) {
    gutenbergScrollAnims = true;
    if ( $('content-left img').length ) {
      $('.content-left img').on('load', function(){
        $('.content-left strong').each(function(){
          let offset = $(this).get(0).getBoundingClientRect().top;
          $(this).data('offset', offset);
          $(this).addClass('to-reveal');
        });
      }).each(function(){
        if ( this.complete )
            $(this).trigger('load');
      });
    } else {
      $('.content-left strong').each(function(){
        let offset = $(this).get(0).getBoundingClientRect().top;
        $(this).data('offset', offset);
        $(this).addClass('to-reveal');
      });
    }
  }

  const needsScrollTrigger = '.wp-block-graph, .image-quote';

  if ( $(needsScrollTrigger).length ) {
    gutenbergScrollAnims = true;
    if ( $('content-left img').length ) {
      $(needsScrollTrigger).on('load', function(){
        $('.content-left strong').each(function(){
          let offset = $(this).get(0).getBoundingClientRect().top;
          $(this).data('offset', offset);
          $(this).addClass('to-reveal');
        });
      }).each(function(){
        if ( this.complete )
            $(this).trigger('load');
      });
    } else {
      $(needsScrollTrigger).each(function(){
        let offset = $(this).get(0).getBoundingClientRect().top;
        $(this).data('offset', offset);
        $(this).addClass('to-reveal');
      });
    }
  }

// if($(".image-quote").length){
// $(window).on('scroll',function(){
//   $(".image-quote").
//
//
//
//
// });
//   }

  if ( $('.child-post-nav__container').length ) {
    childpostNavHeight = $('.child-post-nav__container').get(0).getBoundingClientRect().top;
    $('.child-post-nav__container').addClass('to-reveal');
    if ( $(window).scrollTop() + $(window).height() >= childpostNavHeight ) {
      setTimeout(function() {
        $('.child-post-nav__container').removeClass('to-reveal');
      }, 500);
    }
    $(window).on('scroll', function(){
      const scrolled = $(window).scrollTop() + $(window).height();
      if ( scrolled >= childpostNavHeight ) {
        $('.child-post-nav__container').removeClass('to-reveal');
      }
    });
  }

  if ( $('.tooltip').length ) {
    $('.tooltip-box').each(function(){
      adjustTooltip($(this));
    });

    $('a.tooltip').click(function(e){
      e.preventDefault();
      $( $(this).attr('href') ).focus();
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  // map block
  if ( $('.map-container').length ) {
    $('.map-copy-container').slick({
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      adaptiveHeight: true
    });

    const mapDict = {};

    $('.country-quote').each(function(index){
      const countryCode = $(this).data('countrycode');
      mapDict[index] = countryCode;
      $('.map-container path#' + countryCode).addClass('active');
      if ( index == 0 ) {
        $('.map-container path#' + countryCode).addClass('current');
        const offset = $('.map-container path.current' ).offset();
        const containerOffset = $('.map-container').offset();
        const width = $('.map-container path.current' )[0].getBoundingClientRect().width;
        const height = $('.map-container path.current' )[0].getBoundingClientRect().height;

        const left = Math.floor(offset.left + (width / 2));
        const contentMarginOffset = $('.map-copy-container').offset().left;
        const contentMarginWidth = $('.map-copy-container')[0].getBoundingClientRect().width;

        const adjustedForLeft = (contentMarginOffset + 48 > left) ? contentMarginOffset + 48 : left;


        $('.map-container .pointer').css({
          left: (( adjustedForLeft < contentMarginOffset + contentMarginWidth ) ? adjustedForLeft : contentMarginOffset + contentMarginWidth - 48  ) + 'px',
          top: Math.floor(offset.top - containerOffset.top + (height / 2) ) + 'px'
        });
      }


      $('.map-container path#' + countryCode).attr('tabindex', 0);
      $('.map-container path#' + countryCode).on('click', function(){
        $('.map-copy-container').slick('slickGoTo', index);
        $('.map-copy-container').slick('slickPause');
        setTimeout(function(){
          $('.map-copy-container').slick('slickPlay');
        }, 12000);
      }).on('keypress', function(){
        $(this).trigger('click');
      });
    });

    $('.map-copy-container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.map-container path').removeClass('current');
      $('.map-container path#' + mapDict[nextSlide] ).addClass('current');
      const offset = $('.map-container path#' + mapDict[nextSlide] ).offset();
      const containerOffset = $('.map-container').offset();
      const width = $('.map-container path#' + mapDict[nextSlide] )[0].getBoundingClientRect().width;
      const height = $('.map-container path#' + mapDict[nextSlide] )[0].getBoundingClientRect().height;

      const left = Math.floor(offset.left + (width / 2));
      const contentMarginOffset = $('.map-copy-container').offset().left;
      const contentMarginWidth = $('.map-copy-container')[0].getBoundingClientRect().width;

      const adjustedForLeft = (contentMarginOffset + 48 > left) ? contentMarginOffset + 48 : left;


      $('.map-container .pointer').animate({
        left: (( adjustedForLeft < contentMarginOffset + contentMarginWidth ) ? adjustedForLeft : contentMarginOffset + contentMarginWidth - 48  ) + 'px',
        top: Math.floor(offset.top - containerOffset.top + (height / 2) ) + 'px'
      }, 600);
      // $('.map-container .pointer').css('left', Math.floor(offset.left + (width / 2)) + 'px');
      // $('.map-container .pointer').css('top', Math.floor(offset.top - containerOffset.top + (height / 2) ) + 'px');
    });
  }

  if ( $('.wp-block-ie-piechart').length ) {
    $('.pie ellipse').on('mouseenter', function(){
      const source = $(this).attr('class');
      console.log(source);
      $('.wp-block-ie-piechart__key li.' + source).addClass('active');
      $('.pie ellipse.outer.' + source).addClass('active');
    });

    $('.pie ellipse').on('mouseout', function(){
      const source = $(this).attr('class');
      console.log(source);
      $('.wp-block-ie-piechart__key li.' + source).removeClass('active');
      $('.pie ellipse.outer.' + source).removeClass('active');
    });
  }

  if ( $('.wp-block-ie-maturityscale__table').length ) {
    console.log($('.wp-block-ie-maturityscale__description'));
    $('.wp-block-ie-maturityscale__description').each(function(){
      console.log('hello');
      maturityScaleScrolling($(this));
      $(this).on('scroll', function(){
        if ( $(this).scrollTop() > 0 ) {
          $(this).removeClass('scrollable');
        } else {
          $(this).addClass('scrollable');
        }
      })
    });
  }

  if ( $('.ungp-carousel').length ) {
    $('.ungp-carousel').each(function(){
      const controls = $(this).closest('.ungp-carousel__container').find('.ungp-carousel__controls');
      const slideCount = $(this).find('.ungp-carousel__item').length;
      const thisRef = $(this);
      $(this).slick({
        centerMode: true,
        centerPadding: '20%',
        appendArrows: controls,
        appendDots: controls,
        dots: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="4px" height="8px" viewBox="0 0 4 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polyline id="Path-36-Copy" stroke="#262626" transform="translate(1.998864, 4.119598) rotate(180.000000) translate(-1.998864, -4.119598) " points="3.99772867 1 6.82121026e-13 4.17319215 3.99772867 7.23919535" fill="none"></polyline></svg><span class="screen-reader-text">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="4px" height="8px" viewBox="0 0 4 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polyline id="Path-36-Copy" stroke="#262626" transform="translate(1.998864, 4.119598) rotate(180.000000) translate(-1.998864, -4.119598) " points="3.99772867 1 6.82121026e-13 4.17319215 3.99772867 7.23919535" fill="none"></polyline></svg><span class="screen-reader-text">Next</span></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: false
            }
          }
        ]
      });

      $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        console.log(currentSlide, nextSlide);
        if ( currentSlide == (slideCount - 1) && nextSlide == 0 ) {
          console.log("add faux transition");
          thisRef.find('.slick-slide').not('.slick-cloned').eq(currentSlide).next().addClass('slick-faux-active');
          thisRef.find('.slick-slide').not('.slick-cloned').eq(currentSlide).addClass('slick-faux-inactive');
        } else if ( currentSlide == 0 && nextSlide == (slideCount - 1) ) {
          thisRef.find('.slick-slide').not('.slick-cloned').eq(0).prev().addClass('slick-faux-active');
          thisRef.find('.slick-slide').not('.slick-cloned').eq(0).addClass('slick-faux-inactive-alt');
        }
      });

      $(this).on('afterChange', function(event, slick, currentSlide){

        if ( currentSlide == 0 ) {
          thisRef.find('.slick-slide').not('.slick-cloned').eq(slideCount - 1).next().removeClass('slick-faux-active');
          thisRef.find('.slick-slide').not('.slick-cloned').eq(slideCount - 1).removeClass('slick-faux-inactive');
        } if ( currentSlide == slideCount - 1 ) {
          thisRef.find('.slick-slide').not('.slick-cloned').eq(0).prev().removeClass('slick-faux-active');
          thisRef.find('.slick-slide').not('.slick-cloned').eq(0).removeClass('slick-faux-inactive-alt');
        }
      });

      $(this).find('img').on('click', function(){
        if ( $(this).closest('.ungp-carousel__item').hasClass('slick-active') ) {
          const newImg = $(this).get(0).cloneNode();
          const modal = document.createElement('div');
          modal.classList.add('ungp-modal');
          modal.appendChild(newImg);
          document.querySelector('body').appendChild(modal);
          $(modal).hide().fadeIn();

          $(modal).on('click', function(){
            $(this).fadeOut(500, function(){
              $(this).get(0).remove();
            });
          });
        }
      });
    });
  }
});

function maturityScaleScrolling(el) {
  if ( $(el).get(0).scrollHeight > $(el).get(0).clientHeight ) {
    $(el).addClass("scrollable");
  } else {
    $(el).removeClass('scrollable');
  }

}

$(window).scroll(()=>{
  let scrolled = $(window).scrollTop();

  // gutenberg scroll anims
  if (gutenbergScrollAnims) {
   $('.content-left .to-reveal').each(function() {
     if (scrolled + windowHeight - blockTriggerHeight >= $(this).data('offset')) {
       /* TO BRING BACK BOLD TAG HIGHLIGHTING UNCOMMENT THIS SECTION */
       $(this).removeClass('to-reveal');
       $(this).addClass('revealed');
     }
   });
  }
});

$(window).resize(()=>{
  updateWindowSizeMeta();

  if ( $('.content-left strong').length ) {
    $('.content-left strong').each(function(){
      let offset = $(this).get(0).getBoundingClientRect().top;
      // console.log(offset);
      $(this).data('offset', offset);
    });
  }
});

function updateWindowSizeMeta() {
  windowSize = $(window).width();
  windowHeight = $(window).height();
  isMobile = windowSize <= 767;
}



function dropCap(target) {
  let text = $(target).html();
  text = text.replace(/^((\S+\s+){2}\S+)/, '<span class="lead-text">$1</span>');
  target.html(text);
}



function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function adjustTooltip(el) {
  el.attr('style', '');
  if ( (el.offset().left + el.outerWidth()) >= $(window).width() ) {
    el.css('right', ( (el.offset().left + el.outerWidth()) - $(window).width() - 2 + 12 ) + 'px');
  } else if ( el.offset().left < 0 ) {
    console.log(Math.ceil( Math.abs( el.offset().left ) ));
    el.css('right', Math.ceil( Math.abs( el.offset().left ) ) + 'px' );
  }
}
